import { useState } from "react";
import DataUploader from "./DataUploader";
import DataVisualizer from "./DataVisualizer";

export default function AnalysisPage() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="analysis-page">
      <div className="analysis-page-header">
        <div>
          <h1>Growth Analysis</h1>
          <p>Analysiere Reichweite, Wachstum und Content-Performance.</p>
        </div>

        <DataUploader
          onUploadSuccess={() =>
            setRefreshKey((current) => current + 1)
          }
        />
      </div>

      <DataVisualizer refreshKey={refreshKey} />
    </div>
  );
}